/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hold_Ctrl_Or_Command_To_Select_MultipleInputs */

const en_hold_ctrl_or_command_to_select_multiple = /** @type {(inputs: Hold_Ctrl_Or_Command_To_Select_MultipleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hold Ctrl (Windows) or Command (Mac) to select multiple languages.`)
};

const fr_hold_ctrl_or_command_to_select_multiple = /** @type {(inputs: Hold_Ctrl_Or_Command_To_Select_MultipleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maintenez Ctrl (Windows) ou Commande (Mac) pour sélectionner plusieurs langues.`)
};

const de_hold_ctrl_or_command_to_select_multiple = /** @type {(inputs: Hold_Ctrl_Or_Command_To_Select_MultipleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Halten Sie Strg (Windows) bzw. Befehl (Mac) gedrückt, um mehrere Sprachen auszuwählen.`)
};

const it_hold_ctrl_or_command_to_select_multiple = /** @type {(inputs: Hold_Ctrl_Or_Command_To_Select_MultipleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tieni premuto Ctrl (Windows) o Comando (Mac) per selezionare più lingue.`)
};

const ru_hold_ctrl_or_command_to_select_multiple = /** @type {(inputs: Hold_Ctrl_Or_Command_To_Select_MultipleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Для выбора нескольких языков удерживайте клавишу Ctrl (Windows) или Command (Mac).`)
};

const es_hold_ctrl_or_command_to_select_multiple = /** @type {(inputs: Hold_Ctrl_Or_Command_To_Select_MultipleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mantenga presionada la tecla Ctrl (Windows) o Comando (Mac) para seleccionar varios idiomas.`)
};

const zh_cn2_hold_ctrl_or_command_to_select_multiple = /** @type {(inputs: Hold_Ctrl_Or_Command_To_Select_MultipleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`按住 Ctrl 键（Windows）或 Command 键（Mac）可选择多种语言。`)
};

const ja_hold_ctrl_or_command_to_select_multiple = /** @type {(inputs: Hold_Ctrl_Or_Command_To_Select_MultipleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`複数の言語を選択するには、Ctrl キー (Windows) または Command キー (Mac) を押し続けます。`)
};

const hi_hold_ctrl_or_command_to_select_multiple = /** @type {(inputs: Hold_Ctrl_Or_Command_To_Select_MultipleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एक से अधिक भाषाएँ चुनने के लिए Ctrl (Windows) या Command (Mac) को दबाकर रखें।`)
};

const pt_pt2_hold_ctrl_or_command_to_select_multiple = /** @type {(inputs: Hold_Ctrl_Or_Command_To_Select_MultipleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mantenha pressionada a tecla Ctrl (Windows) ou Command (Mac) para selecionar vários idiomas.`)
};

/**
* | output |
* | --- |
* | "Hold Ctrl (Windows) or Command (Mac) to select multiple languages." |
*
* @param {Hold_Ctrl_Or_Command_To_Select_MultipleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const hold_ctrl_or_command_to_select_multiple = /** @type {((inputs?: Hold_Ctrl_Or_Command_To_Select_MultipleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hold_Ctrl_Or_Command_To_Select_MultipleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_hold_ctrl_or_command_to_select_multiple(inputs)
	if (locale === "de") return de_hold_ctrl_or_command_to_select_multiple(inputs)
	if (locale === "it") return it_hold_ctrl_or_command_to_select_multiple(inputs)
	if (locale === "ru") return ru_hold_ctrl_or_command_to_select_multiple(inputs)
	if (locale === "es") return es_hold_ctrl_or_command_to_select_multiple(inputs)
	if (locale === "zh-CN") return zh_cn2_hold_ctrl_or_command_to_select_multiple(inputs)
	if (locale === "ja") return ja_hold_ctrl_or_command_to_select_multiple(inputs)
	if (locale === "hi") return hi_hold_ctrl_or_command_to_select_multiple(inputs)
	if (locale === "pt-PT") return pt_pt2_hold_ctrl_or_command_to_select_multiple(inputs)
	return en_hold_ctrl_or_command_to_select_multiple(inputs)
});